import { flagFactory } from '../icon';
import Svg from './lv.svg';

export default flagFactory(Svg);
